export const environment = {
  production: true,
  showDemoButton: false,
  apiBaseUrl: 'https://api.agrigateone.com',
  webSocketUrl: 'wss://api.agrigateone.com/cable',
  authentication: {
    auth0Domain: 'agrigate.eu.auth0.com',
    clientID: '9OWk3exU6HF3IZOB4lO0LYrCEX3Do2hB',
    redirectURI: 'https://app.agrigateone.com/login/callback',
    audience: 'https://api.agrigate.com',
    webappUrl: 'https://app.agrigateone.com',
    logoutUrl: 'https://app.agrigateone.com/login',
  },
  pusher: {
    key: '63f9e77a43c7876e9dca',
    options: {
      cluster: 'eu',
      encrypted: true,
    },
  },
  sentry: {
    environment: 'production',
    dsn: 'https://f992693bf9654428972bd8968d2a13fa@sentry.io/1365705',
    logToSentry: true,
  },
  oneSignal: {
    appId: '033ad3a1-02ea-4565-af07-472f266b1de0',
  },
  freshdesk: {
    domain: 'agrigate',
  },
  gcp: {
    maps: {
      apiKey: 'AIzaSyBiJXMwNwB83uBb5yyaN-P6CamuCA-6ZOE',
    },
  },
};
